<template>
  <div class="text-center">
    <v-dialog max-width="800px" width="100%" v-model="dialog" class="">
      <template v-slot:activator="{ on }">
        <slot name="activator" :on="on" />
      </template>
      <v-card>
        <v-toolbar flat="">
          <v-card-title>Phone Preview</v-card-title>

          <v-spacer></v-spacer>

          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <div class="pa-4 pt-0">
          <phone style="max-width:300px" :messages="messages" class="ma-auto" />
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import phone from "@/components/mock-phone";

export default {
  components: {
    phone
  },
  props: ["messages"],
  data: () => ({
    dialog: false
  })
};
</script>

<style></style>
